import api from "lib/axios";

type ApiSuccess<T> = { status: "success" | string; result: { data: T }; message: string };

export type NotificationPreferences = {
  chat_enabled: boolean;
  announcements_enabled: boolean;
  system_enabled: boolean;
};

export const instructorNotificationPreferencesService = {
  async get(): Promise<NotificationPreferences> {
    const response = await api.get<ApiSuccess<NotificationPreferences>>(
      "/instructors/notification-preferences"
    );
    return response.data.result?.data;
  },

  async update(body: Partial<NotificationPreferences>): Promise<NotificationPreferences> {
    const response = await api.put<ApiSuccess<NotificationPreferences>>(
      "/instructors/notification-preferences",
      body
    );
    return response.data.result?.data;
  },
};
